import React, { Component } from 'react'

export default class ModalMessage extends Component {
    render() {
        const {messageModal,email,emailModal, ClosemessageModal,CloseEmailModal,withoutEmail} = this.props
        return (
                <div className={`user_popup ${email ? emailModal ?  "active" : null : messageModal ?  "active" : null }`}>
                    <span className="popup_overlay" onClick={ClosemessageModal}></span>
                    <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                        <div className="approve_popup_header text_center relative">
                            <p>{withoutEmail}</p>
                            {email &&
                                <p>The email {email} already exists as a user. Please use another email for this new role.</p>
                            }
                        </div>
                        <div className="content">
                            <div className="field_row text_center">
                                <button className="small_btn active" onClick={email ? CloseEmailModal : ClosemessageModal}>OK</button>
                            </div>
                        </div>
                    </div>
                </div>
        )
    }
}
